export default __webpack_public_path__ + "static/media/solidario11.e63cff92.jpeg";